import React from "react"

const LearnMoreIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.55176 1.58203C5.27832 1.85547 5.30566 2.26562 5.55176 2.53906L8.86035 5.65625H1.0127C0.629883 5.65625 0.356445 5.95703 0.356445 6.3125V7.1875C0.356445 7.57031 0.629883 7.84375 1.0127 7.84375H8.86035L5.55176 10.9883C5.30566 11.2617 5.30566 11.6719 5.55176 11.9453L6.15332 12.5469C6.42676 12.793 6.83691 12.793 7.08301 12.5469L12.415 7.21484C12.6611 6.96875 12.6611 6.55859 12.415 6.28516L7.08301 0.980469C6.83691 0.734375 6.42676 0.734375 6.15332 0.980469L5.55176 1.58203Z"
        fill="#46B839"
      />
    </svg>
  )
}
export default LearnMoreIcon
